import { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

export default function ConfettiCelebration({ milestone }) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!milestone || firedRef.current) return;
    firedRef.current = true;

    const intensity = getIntensity(milestone);

    if (intensity === 'epic') {
      // 100+ days: grand celebration
      const duration = 3000;
      const end = Date.now() + duration;
      const interval = setInterval(() => {
        confetti({
          particleCount: 50,
          spread: 100,
          origin: { x: Math.random(), y: Math.random() * 0.6 },
          colors: ['#6366F1', '#EC4899', '#EAB308', '#22C55E', '#F97316'],
        });
        if (Date.now() > end) clearInterval(interval);
      }, 200);
    } else if (intensity === 'big') {
      // 30-99 days: solid celebration
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#6366F1', '#EC4899', '#EAB308'],
      });
      setTimeout(() => {
        confetti({
          particleCount: 50,
          spread: 100,
          origin: { y: 0.6 },
        });
      }, 500);
    } else {
      // 7-29 days: simple celebration
      confetti({
        particleCount: 50,
        spread: 60,
        origin: { y: 0.7 },
        colors: ['#6366F1', '#22C55E'],
      });
    }

    return () => {
      firedRef.current = false;
    };
  }, [milestone]);

  return null;
}

function getIntensity(days) {
  if (days >= 100) return 'epic';
  if (days >= 30) return 'big';
  return 'small';
}
